import Vue from 'vue';
import Vuei18n from 'vue-i18n';
import en from './en.json';
import es from './es.json';
import fr from './fr.json';
// import { getBrowserSettingsLanguage } from '@/store/getters.js';


Vue.use(Vuei18n);
let lang = localStorage.getItem("lang");
// console.log(lang);
if (lang && lang != '') {
  localStorage.setItem("lang", lang);
} else {
  let locLang = (navigator.language || navigator.userLanguage).split('-')[0];

  if (locLang && locLang == 'es')
    lang = 'es';
  else if (locLang && locLang == 'fr')
    lang = 'fr';
  else
    lang = 'en';

  localStorage.setItem("lang", lang);
}
// let lang = navigator.language || navigator.userLanguage;
// console.log(lang);
// let locLang = localStorage.getItem("lang");
// if (locLang == "") {
// if (lang.split('-')[0] == 'es') {
// localStorage.setItem("lang", 'es');
// } else {
// localStorage.setItem("lang", 'en');
// }

const i18n = new Vuei18n({
  // locale: getBrowserSettingsLanguage || 'en',
  locale: localStorage.getItem("lang") || 'en',
  messages: {
    en: en,
    es: es,
    fr: fr
  }
})

export default i18n;


// WEBPACK FOOTER //
// ./src/lang/i18n.js